import moment from 'moment';
import React from 'react';
import { FormattedDate } from 'react-intl';
import { EquipmentStates } from '../../../../common/src/enums/EquipmentStates';
import { useTranslate } from '../../mixins/translate/translate';

interface IExpirationLabel {
    status: string;
    dateEndCertificateValidity: string | null;
    dateReminderRecertification: string | null;
}

function statusToClassName(data: IExpirationLabel) {
    if (data.status === EquipmentStates.OutOfService || data.status === EquipmentStates.Deleted) {
        return 'label-muted';
    }
    if (!data.dateEndCertificateValidity) {
        return 'label-info';
    }

    const currentDate = new Date();
    const expirationDate = new Date(data.dateEndCertificateValidity);

    if (currentDate > expirationDate) {
        return 'label-danger';
    }

    if (!data.dateReminderRecertification) {
        return 'label-info';
    }

    const reminderDate = new Date(data.dateReminderRecertification);

    if (currentDate > reminderDate) {
        return 'label-warning';
    }
    return 'label-info';
}

export function EquipmentExpirationLabel(props: { data: IExpirationLabel; showDays?: boolean }) {
    const translate = useTranslate();
    if (!props.data.dateEndCertificateValidity) {
        return null;
    }

    if (props.showDays) {
        const currentDate = moment(new Date());
        let diffInDays = moment(props.data.dateEndCertificateValidity).diff(moment(currentDate), 'days');
        if (diffInDays < 0) {
            diffInDays = 0;
        }
        return (
            <span className={`label ${statusToClassName(props.data)}`}>
                {diffInDays}&nbsp;{translate('common.days')}
            </span>
        );
    }
    return (
        <span className={`label ${statusToClassName(props.data)}`}>
            <FormattedDate value={props.data.dateEndCertificateValidity} year="numeric" month="short" day="numeric" />
        </span>
    );
}
